module.exports = __webpack_public_path__ + "img/persona_flexsale.112b3a85.png";